<template>
    <div :class="theme.tariffTableWrap">
        <v-toggle-button-group v-margin.left="1" v-margin.bottom="1">
            <v-toggle-button value="regular" label="На месяц" @click="handleDeviceChange" :selected="selectedTariffsTab === 'regular'"/>
            <v-toggle-button value="quarter" label="На 3 месяца" extra="выгода 33%" @click="handleDeviceChange" :selected="selectedTariffsTab === 'quarter'"/>
        </v-toggle-button-group>
        <table :class="[theme.tariffTable, theme.tariffTableSelected]" :data-selected="2">
            <thead>
                <tr>
                    <th>
                        <v-text bold type='subheadling'>Модули</v-text>
                    </th>
                    <th v-for="tariff, index in currentTariffs" :key="index">
                        <div style="width: 175px;">
                            <v-text nowrap bold>
                                {{tariff.cost ? 'Тариф' : null}} {{tariff.title}}
                            </v-text>
                        </div>
                        <div>
                            <v-text v-if="tariff.cost" nowrap :class="theme.tariffTableDesc">
                                {{numberWithSpaces(tariff.cost)}} {{selectedTariffsTab === 'regular' ? '₽/ 1 месяц' : '₽/ 3 месяца'}}
                            </v-text>
                        </div>
                        <div>
                            <v-text v-if="tariff.discount" nowrap :class="theme.tariffTableSale">
                                Выгода {{tariff.discount}}%
                            </v-text>
                        </div>
                    </th>
                </tr>
            </thead>

            <tbody>
                <tr v-for="product, productId in firstTariffProducts" :key="productId">
                    <td>
                        <v-text>{{ product.title }}</v-text>
                    </td>
                    <td v-for="tariff, index in currentTariffs" :key="index">
                        <v-text nowrap>
                            {{ tariff.products.find(x => x.id == product.id) ? `${tariff.products.find(x => x.id == product.id).cost} ₽/шт` : null }}
                        </v-text>
                    </td>
                </tr>
                <tr>
                    <td>
                        <v-text>Анализ КИ</v-text>
                    </td>
                    <td>
                        <v-text nowrap>
                            390 ₽/шт
                        </v-text>
                    </td>
                    <td>
                        <v-text nowrap>
                            295 ₽/шт
                        </v-text>
                    </td>
                    <td>
                        <v-text nowrap>
                            250 ₽/шт
                        </v-text>
                    </td>   
                    <td>
                        <v-text nowrap>
                            200 ₽/шт
                        </v-text>
                    </td>                 
                </tr>
                <tr>
                    <td>
                        <v-text>Ошибки КИ</v-text>
                    </td>
                    <td>
                        <v-text nowrap>
                            300 ₽/шт
                        </v-text>
                    </td>
                    <td>
                        <v-text nowrap>
                            300 ₽/шт
                        </v-text>
                    </td>
                    <td>
                        <v-text nowrap>
                            300 ₽/шт
                        </v-text>
                    </td>   
                    <td>
                        <v-text nowrap>
                            300 ₽/шт
                        </v-text>
                    </td>                 
                </tr>
            </tbody>

            <tfoot>
                <tr>
                    <td></td>
                    <td v-for="tariff, index in currentTariffs" :key="index">
                        <v-router-link v-if="tariff.cost" :to="{ name: 'tariffBuy', params: { tariff: tariff.id } }">
                            <v-button primary block>
                                купить
                            </v-button>
                        </v-router-link>
                        <v-text v-else>
                            <v-router-link :to="{ name: 'pricing' }">
                                Перейти
                            </v-router-link>
                        </v-text>
                    </td>
                </tr>
            </tfoot>
        </table>
    </div>
</template>
<script>
    import { numberWithSpaces } from '../../../helpers';
    import theme from './theme.scss';

    export default {
        name: 'tariffs-table',
        data(){
            return {
                selectedTariffsTab: "regular"
            }
        },
        props: {
            tariffs: {
                type: [Array, Object],
                default() {
                    return [];
                }
            },
            selected: [String, Number],
            theme: {
                type: Object,
                default() {
                    return theme;
                }
            }
        },
        methods: {
            handleDeviceChange(value){
                this.selectedTariffsTab = value
            },
            numberWithSpaces,
        },
        computed: {
            currentTariffs(){
                return this.selectedTariffsTab === 'regular' ? this._props.tariffs.filter(t => !t.isQuarter) : this._props.tariffs.filter(t => t.isQuarter);
            },
            firstTariff() {
                const keys = Object.keys(this.tariffs);

                return this.tariffs && this.tariffs[keys[0]];
            },
            firstTariffProducts() {
                return this.firstTariff
                    ? this.firstTariff.products
                    : [];
            },
            selectedTariff() {
                return this.selected ? Object.values(this.tariffs)
                    .findIndex((tariff) => Number(tariff.id) === Number(this.selected)): -1;
            }
        }
    }
</script>


// WEBPACK FOOTER //
// TariffsTable.vue?7c55cb72